// 中文版----address
module.exports = {
  validate: {
    noEmail: "Email cannot be empty, please re-enter",
    noPhone: "The phone number cannot be empty, please re-enter",
    errorReg:
      "The input length is 1-50 digits, you can enter uppercase and lowercase letters, numbers, symbols - . _ @",
    noPassword: "The password cannot be empty, please re-enter",
    pwdReg:
      "Password input length is 8-32 digits, only and must contain numbers and letters",
    pwdCheck: "The two passwords entered are inconsistent, please re-enter",
    pwdLengthReg:
      "The password length ranges from 8 to 32, please confirm the input",
    noCode: "please enter verification code",
    codeReg: "Please enter a 6-digit verification code",
    nullText: "The input cannot be empty, please re-enter",
    phoneCheck:
      "The phone number entered twice is inconsistent, please re-enter",
    emailNumReg: "The email input length is 6-50 characters, please re-enter",
    emailReg: "Incorrect email address, please re-enter",
    emailCheck: "Twice entered email account is inconsistent, please re-enter",
    noUsername:
      "The password cannot contain the account number, please re-enter",
    accountReg: "Account name input is incorrect, please re-enter",
  },
  area: {
    areaTitle: "Area Management",
    add: "Add area",
    area: "area",
    addNextArea: "Create a new subordinate area",
    areaNameTip: "Please enter a region name",
    areaNameHold:
      "The input length is 1-20 digits, no special symbols can be entered",
    areaNumHold:
      "The input length is 1-4 digits, only numbers can be entered, and the number range is 0-9999",
    areaNumTip: "Please enter the area number",
    areaName: "Area Name",
    checkAreaName: "Area name cannot be empty, please re-enter",
    areaNameTip1: "Area name cannot be empty",
    areaNameTip2: "Incorrect area name input, please re-enter",
    areaNum: "Area Number",
    checkAreaNum: "Area ID cannot be empty, please re-enter",
    lastLevel: "Belongs to the superior area",
    checkLastLevel:
      "The upper-level area to which it belongs cannot be empty, please select again",
    lastLevelTip: "Please select the parent area to which you belong",
    delInfo:
      "Executing this delete task will delete the data in this area and cannot be recovered",
    oneStep: "level one",
    twoStep: "secondary",
    threeStep: "Level 3",
    fourStep: "Level 4",
    fiveStep: "Level 5",
    delAreaTip: "There is a subordinate area, which cannot be deleted",
    personArea: "The person is not bound to the area",
    areaType: "Add method",
    addArea1: "Add separately",
    addArea2: "continuous addition",
    addArea3: "Matrix addition",
    areaNameTop: "Zone Name Prefix",
    areaNameLast: "Zone Name Suffix",
    areaJoinHold: "Please enter the domain name prefix",
    areaJoinHold1: "Please enter the area name suffix",
    startNum: "Start number",
    checkStartNum: "The initial number input is wrong, please re-enter",
    checkStartNum1:
      "The input of the starting number cannot be empty, please re-enter",
    checkEndNum: "End number input is wrong, please re-enter",
    checkEndNum1: "End number cannot be empty, please re-enter",
    endNum: "End number",
    topStart: "Header start number",
    checkTopStart:
      "The input of the first starting number is incorrect, please re-enter",
    checkTopStart1:
      "The input of the first starting number cannot be empty, please re-enter",
    topEnd: "Header end number",
    checkTopEnd:
      "Enter the end number of the header is incorrect, please re-enter",
    checkTopEnd1:
      "The input of the first end number cannot be empty, please re-enter",
    lastStart: "Tail start number",
    checkLastStart:
      "The input of the tail start number is wrong, please re-enter",
    checkLastStart1:
      "Enter the tail start number cannot be empty, please re-enter",
    lastEnd: "Trail End Number",
    checkLastEnd: "Enter the end number of the tail is wrong, please re-enter",
    checkLastEnd1:
      "The input of the tail end number cannot be empty, please re-enter",
    topTip:
      "The input length is 1-2 digits, only numbers can be entered, and the number range is 1-99",
    lastTip:
      "The input length is 1-2 digits, only numbers can be entered, and the number range is 1-99",
    areaNameTest: "Area name example",
  },
  addressBook: {
    config: "Project Configuration",
    errorTip: "Address book format error",
    upgrade: "Address Book Upgrade Management",
    deviceIdTip: "Please enter the device ID",
    deviceId: "Device ID",
    syncAll: "Sync all",
    sync: "Synchronize",
    sysVersion: "Current System Address Book Version",
    deviceVersion: "Current device address book version",
    syncTip: "Successfully issued the synchronous command",
  },
  newarea: {
    add: "Add area",
    edit: "Edit Area",
    smallTip:
      "Currently the smallest area level, no further sub-areas can be added",
    batch: "Batch add area",
    batch1: "continuous addition",
    batch2: "Matrix addition",
  },
  deviceSip: {
    saveTip:
      "Please export the address book in time, otherwise all data will be cleared after exiting the page.",
    devMsg: "Device Information",
    list: "Device List",
    add: "Add Device",
    edit: "Edit Device",
    batch: "Add devices in batches",
    areaChosen: "Area level selection",
    areaNum: "Number of newly added devices in each area",
    bacthTip:
      "When the area level is selected as a building, and the number of new devices in each area is 4, it means that 4 devices are added in each created area",
    note: "illustrate",
    baseConfig: "Basic Information Configuration",
    deviceName: "Device Name",
    nameTip:
      "Fixed to add a number to the name of the group to which it belongs, for example, Building 1-1",
    function: "Device support function",
    net: "Network Configuration",
    netType: "Network Type",
    netTip1:
      "Static is a static network, you need to manually set the IP and other information.",
    netTip2:
      "DHCP is a dynamic network, and information such as IP is automatically assigned by the router.",
    mask: "Please enter the subnet mask",
    gateway: "Please enter the gateway",
    ip: "Please enter the IP address",
    ipTip:
      "The input IP address needs to avoid special IP, such as 127.0.0.1, etc.",
    dns1: "Please enter DNS1",
    dns2: "Please enter DNS2",
    sip1: "sip1 information configuration",
    config: "Information configuration",
    mode: "model",
    mode1: "Direct Mode",
    mode2: "Server Mode",
    user: "please enter user name",
    userTitle: "username",
    userTip: "The default is to add a number to the group name, such as 1-1-1",
    last: "Please enter the account suffix",
    sipTip:
      "Please enter the registered user name and password of the SIP server",
    password: "Please enter your password",
    passwordTitle: "password",
    serverIp: "Please enter serverIP",
    protocolType: "Please select the protocol type",
    protocolTypeTitle: "agreement type",
    sip2: "sip2 information configuration",
    more: "More",
    close: "closure",
    formatError: "Format error, please re-enter",
    forbidTip: "Forbidden to enter 127.0.0.1, please re-enter",
    call: "Call in and call out",
    monitor: "monitor",
    lift: "Elevator Control",
    rtsp: "rtsp video stream",
    deviceTip:
      "The device support function cannot be empty, please choose again",
    maskTip1: "The subnet mask cannot be empty, please re-enter",
    maskTip2: "The format of the subnet mask is wrong, please re-enter",
    gatewayTip1: "Gateway cannot be empty, please re-enter",
    gatewayTip2: "Gateway format error, please re-enter",
    ipTip1: "The IP address cannot be empty, please re-enter",
    ipTip2:
      "IP address format error, the upper limit is 255.254.254.253, the first paragraph is not 0, please re-enter",
    dns1Tip1: "DNS1 cannot be empty, please re-enter",
    dns1Tip2: "DNS1 format error, please re-enter",
    dns2Tip1: "DNS2 format error, please re-enter",
    passwordTip1: "The password cannot be empty, please re-enter",
    serviceTip1: "serviceIp cannot be empty, please re-enter",
    serviceTip2: "serviceIp format error, please re-enter",
    sip2Tip:
      "You have currently configured sip2 information, please complete it according to the rules",
    devnameTip1: "The device name cannot be empty, please re-enter",
    devnameTip2: "Device name format error, please re-enter",
    nameTip1: "The user name cannot be empty, please choose again",
    nameTip2: "The user name cannot be empty, please choose again",
    maxTip1:
      "The number of devices in the current area has reached the upper limit of 8, and no more can be added",
    area: "area",
    editArea: "Edit Area",
    addArea: "Add area",
    batchArea: "Batch add area",
    deleteArea: "Delete Region",
    areaName: "Area Name",
    areaNo: "Area Number",
    importAddr: "Import Address Book",
    next: "Next step",
    areaTip1: "Please select the area to be edited first",
    areaTip2: "Please select the area to be deleted first",
    areaTip3:
      "Your current area is empty, you cannot add devices in batches at the moment, please add area information first",
    noArea: "No zone configuration yet",
    error: "Data exception",
    addDevice: "Add Device",
    editDevice: "Edit Device",
    delDevice: "Delete device",
    batchDevice: "Add devices in batches",
    prev: "Previous",
    updateAddr: "Update Device Address Book",
    saveAddr: "Save Address Book",
    exportAddr: "Export Address Book",
    deleteTip: "Whether to delete the device",
    deleteTip2:
      "Currently selected as a region, please return to the region configuration to delete",
    deleteTip3: "Please select the device to be deleted first",
    deviceTip1: "Please select the device to be edited first",
    deviceTip2: "Please select the region first, then add the device",
    exportSuccess: "Export succeeded",
    xmlTip: "Please upload the xml file of the address book",
    xmlTip1: "Please select the xml file to upload",
    xmlTip2:
      "The imported address book is inconsistent with the current community level, and the import failed",
    areaConfig: "Area Configuration",
    deviceConfig: "Device Configuration",
    exportConfig: "Preview Export",
    projectConfig: "Project Configuration",
    prevArea: "Belongs to the superior area",
    areaNoTip:
      "The start number is greater than the end number, please fill in again",
    smallAreaTip:
      "Currently the smallest area level, no further sub-areas can be added",
    areaNoTip1:
      "The start number of the first part is greater than the end number of the first part, please fill in again",
    areaNoTip2:
      "The start number of the tail is greater than the end number of the tail, please fill in again",
  },
  push: {
    list: "Push Record",
    productType: "Product number",
    softwareName: "name of software",
    versionNo: "version number",
    time: "Push time",
    invalidTime: "Expiration time",
    upgrade: "upgrade",
    upgradeRecord: "View upgrade record",
    deviceType: "Equipment type",
    deviceName: "Device Name",
    currentSoftName: "Current device software name",
    currentSoftNo: "Current device version number",
    upgradeNo: "Upgrade software version number",
    filterTip1: "Please enter the device name",
    filterTip2: "Please select the software name",
    filterTip3: "Please select a version number",
    checkTip: "Activate Tick",
    ota: "OTA upgrade",
    taskName: "mission name",
    taskNameTip: "Please enter a task name",
    binName: "Firmware Name",
    upgradeType: "Task upgrade method",
    done: "Whether to execute immediately",
    upgradeTime: "upgrade time",
  },
  check: {
    submit: "Congratulations, the submission is successful!",
    noSubmit: "Oops, submission failed!",
    file: "Select a document",
    noFile: "No file selected",
    projectName: "project name",
    projectNameTip: "Please enter a project name",
    describe: "describe",
    contentTip: "Please enter content",
    areaType: "Region Hierarchy",
    example: "For example: building-unit-room number",
    areaTip: "The area number format is wrong, please re-enter",
    areaNameTip: "Please enter a layer name",
    nameTip: "The name cannot be empty, please re-enter",
    nameError: "The name was entered incorrectly, please re-enter",
    nameLength: "The name input length is 4~50, please re-enter",
    areaNullTip: "Area level cannot be empty",
    formateError: "The length is 1-6 digits, no special symbols can be entered",
    noAreaTip: "Area level cannot be empty, please select again",
    maxFileTip: "File size exceeds limit",
    xmlTip: "Please upload a file in XML format",
  },
  book: {
    areaBy: "Region",
    list: "Device Information Duplicate List",
    repeatTip:
      "The following equipment information is duplicated. Please modify the duplicated equipment information. After clicking 'Confirm ',it will judge the duplication of equipment input information. ",
    coverTip:
      "This operation will overwrite the batch adding data of the currently selected level",
    batchTip: "The IP range generated by adding devices in batches",
  },
  updateNewSip: {
    otaDeleteTip: "Delete failed, only unstarted tasks can be deleted",
    deleteArea1: "Whether to delete the region",
    deleteArea2:
      "At the same time, all areas and devices below this area will be deleted together",
    codeRepeatTip:
      "The region ID of the same level cannot be repeated, please re-enter the current region ID",
    nameRepeatTip:
      "Area names at the same level cannot be duplicated, please re-enter the current region name",
    deviceIp: "Device IP",
    callin: "Call In",
    callout: "exhale",
    systemMsg: "system information",
    batchIpTip: "The IP range generated by adding devices in batches this time",
    ip: "IP address",
    mask: "Subnet Mask",
    gateway: "Gateway",
    noData: "No",
    noAddressTip:
      "There is currently no address book data that can be synchronized",
    operator: "Operator",
    goTip: "Click to jump to the corresponding step",
    deviceNameTip:
      "The input length is 1-16 digits, no special symbols can be entered",
    filter1: "Enter an area name to filter",
    filter2: "Enter area name or device name to filter",
    secret: "Encryption Password",
    secretTip:
      "Please enter a password within 32 characters, the format is not limited",
    noSecretTip: "Encryption password not set can be ignored",
    setSecret: "Set address book encryption password",
    ignore: "neglect",
    emptyBookTip:
      "The address book is empty and cannot be exported temporarily",
    errorSecret: "Address book encryption password error, please re-enter",
    other: "other",
    doorAuth: "Access Control",
    funTitle: "Please check the functions supported by the device you added",
    callInTip: "Device Support Call",
    callOutTip: "Device support is called",
    monitorTip: "The device supports being monitored",
    doorTip: "The device supports unlocking function",
    liftTip: "Device support control elevator",
    maskTip: "Please enter the subnet mask, format reference: 255.255.255.255",
    gatewayTip: "Please enter the gateway, format reference: 1.1.1.1",
    ip1: "Please enter the IP address, format reference: 1.1.1.1",
    ipTip:
      "The input IP address needs to avoid special IP, such as 127.0.0.1, etc.",
    dns1: "Please enter DNS1, format reference: 1.1.1.1",
    dns2: "Please enter DNS2, format reference: 1.1.1.1",
    serverIp: "Please enter serverIp, format reference: 1.1.1.1 or domain name",
    successxml: "File parsed successfully",
    groupCall: "group call",
    groupCallTip:
      "After it is turned on, you can call all devices in the group by clicking the group call icon",
    record: "version record",
    export: "export",
    sync: "Synchronize",
    communityTip:
      "Currently there is area device data, switching area level is prohibited",
    areaNameTitle: "Hierarchy Description",
    noDataTip: "There is currently no data",
    areaCodeDescriptionTip:
      "The hierarchy description cannot be blank, please fill it out completely",
    moduleName: "Address Book Configuration Tool",
    userSipAccount:
      "Fixed as the area number of the parent group+equipment number",
    devMax: "Device node exceeded limit of 10000 entries, failed to add",
    areaMax: "Area node exceeded the limit of 10000 entries, failed to add",
    ipAndMaskTip1:
      "IP address is associated with subnet mask, and needs to pass the business logic validation of having results with all 1s or all 0s after the bitwise AND operation.",
    ipAndMaskTip2:
      "If a business validation rule error occurs, please modify the corresponding IP address.",
    ipAndMaskTip3:
      "The business validation rules of the subnet mask and IP address are incorrect. Please modify the IP address.",
    ipAndMaskTip4:
      "When adding devices in bulk, IPs that do not meet the business logic validation will be automatically skipped.",
    correctMaskTip: "Please fill in the correct subnet mask first.",
    correctIpTip: "Please enter the correct IP address.",
  },
  newDeviceType: {
    indoorMachine: "Indoor unit",
    doorPhone: "Intercom at the door",
    smallDoor: "Small intercom at the door",
    manage: "Management device",
    wall: "Wall-mounted device",
    monitor: "IP camera",
    unitGuard: "Unit management device",
    networkCard: "Network card reader",
    unitCard: "Unit card reader",
    lift: "Elevator linkage module",
    deviceTypeTip: "Please select the device type",
  },
};
